import { render, staticRenderFns } from "./ListTitle.vue?vue&type=template&id=035dd83d&"
import script from "./ListTitle.vue?vue&type=script&lang=js&"
export * from "./ListTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports